import { useTRPC } from "../trpc/client";
import { useMutation } from "@tanstack/react-query";

export function useUpdateUser(
  onSuccessCallback: () => void,
  onErrorCallback: (error: unknown) => void
) {
  const trpc = useTRPC();
  const { mutateAsync, isPending } = useMutation({
    ...trpc.users.update.mutationOptions(),
    onSuccess: onSuccessCallback,
    onError: onErrorCallback,
  });

  return {
    updateUser: mutateAsync,
    isLoading: isPending,
  };
}
